jQuery(document).ready(function(jQuery){
    //if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
    var MqL = 993;
    //move nav element position according to window width
    moveNavigation();

    var isMobile = {
        Android: function() {
            return navigator.userAgent.match(/Android/i);
        },
    };
    // Only apply the following code for non-Android devices since the window resize code was causing issues with the
    // mobile menu search box on android devices

    if(!isMobile.Android()) {
        jQuery(window).on('resize', function(){
            (!window.requestAnimationFrame) ? setTimeout(moveNavigation, 300) : window.requestAnimationFrame(moveNavigation);
        });
    }

    //mobile - open lateral menu clicking on the menu icon
    jQuery('.cd-nav-trigger').on('click', function(event){
        event.preventDefault();
        if( jQuery('.cd-main-content').hasClass('nav-is-visible') ) {
            closeNav();
            jQuery('.cd-overlay').removeClass('is-visible');
            jQuery('body').attr("style","overflow:auto");
            jQuery('#mobile-header-social').addClass('is-hidden');
            // When a user clicks the X to exit the menu, hide the menu items so they dont show during the animation
            jQuery('.dol-agency-submenu').addClass('is-hidden');
            jQuery('.cd-primary-nav').removeClass('nav-is-visible');
        } else {
            jQuery(this).addClass('nav-is-visible');
            jQuery('.cd-primary-nav').addClass('nav-is-visible');
            jQuery('.cd-main-header').addClass('nav-is-visible');
            jQuery('.cd-main-content').addClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
                jQuery('body').attr("style","overflow:hidden; position: fixed");
            });
            toggleSearch('close');
            jQuery('.cd-overlay').addClass('is-visible');
            // Show menu items once user goes back to view the menu
            jQuery('#mobile-header-social').removeClass('is-hidden');
            jQuery('.dol-agency-submenu').removeClass('is-hidden');
        }
    });

    //open search form
    jQuery('.cd-search-trigger').on('click', function(event){
        event.preventDefault();
        toggleSearch();
        closeNav();
    });

    //close lateral menu on mobile
    jQuery('.cd-overlay').on('swiperight', function(){
        if(jQuery('.cd-primary-nav').hasClass('nav-is-visible')) {
            closeNav();
            jQuery('.cd-overlay').removeClass('is-visible');
        }
    });
    jQuery('.nav-on-left .cd-overlay').on('swipeleft', function(){
        if(jQuery('.cd-primary-nav').hasClass('nav-is-visible')) {
            closeNav();
            jQuery('.cd-overlay').removeClass('is-visible');
        }
    });
    jQuery('.cd-overlay').on('click', function(){
        closeNav();
        toggleSearch('close');
        jQuery('.cd-overlay').removeClass('is-visible');
    });


    //prevent default clicking on direct children of .cd-primary-nav
    jQuery('.main-primary-menu.cd-primary-nav').children('.has-children').children('a').on('click', function(event){
        event.preventDefault();
    });
    //open submenu
    jQuery('#cd-primary-nav-secondary-desktop > li > a > span.menuarrow > svg').removeClass('fa-chevron-left').addClass('fa-chevron-down');

    //add selectors to show or hide list items based on click
    jQuery('.cd-primary-nav > .has-children').children('a').on('click', function(event){
        if( !checkWindowWidth() ) event.preventDefault();
        var selected = jQuery(this);
        if(!jQuery(this).parent('li').hasClass('menu-is-open')){
            jQuery(this).parent('li').siblings().addClass('menu-is-active');
            jQuery(this).parent('li').siblings().removeClass('menu-is-open');
            jQuery(this).parent().addClass('menu-is-active menu-is-open');
        }
        else {
            jQuery(this).parent('li').siblings().removeClass('menu-is-active');
            jQuery(this).parent().removeClass('menu-is-active menu-is-open');
        }
        if( selected.next('ul').hasClass('is-hidden') ) {
            //desktop version only
            selected.addClass('selected').next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('moves-out');
            selected.parent('.has-children').siblings('.has-children').children('ul').addClass('is-hidden').end().children('a').removeClass('selected');
            selected.parent('.has-children').attr('aria-haspopup', 'true').end().parent('.has-children').siblings().attr('aria-haspopup', 'false');
            jQuery('.cd-overlay').addClass('is-visible');
            // Hide social media icons if a parent mobile menu item is clicked
            if(jQuery('.moves-out').length) {
                jQuery('#mobile-header-social').hide();
            }
            if (jQuery(window).outerWidth() < 993) {
                // jQuery('.agencysearchblock').addClass('dNone');
                jQuery('#cd-primary-nav-secondary-desktop > li > a > span.menuarrow > svg').addClass('fa-chevron-left');
            }else {
                jQuery('#cd-primary-nav-secondary-desktop > li > a > span.menuarrow > svg').removeClass('fa-chevron-left').addClass('fa-chevron-down');
            }
            jQuery('.cd-main-content').addClass('usa-mobile_nav-active');
        } else {
            selected.removeClass('selected').next('ul').addClass('is-hidden').end().parent('.has-children').parent('ul').removeClass('moves-out');
            selected.parent('.has-children').attr('aria-haspopup', 'false');
            jQuery('.cd-overlay').removeClass('is-visible');
            if (jQuery(window).outerWidth() < 993) {
                // jQuery('.agencysearchblock').removeClass('dNone');
                jQuery('#cd-primary-nav-secondary-desktop > li > a > span.menuarrow > svg').addClass('fa-chevron-down');
            } else {
                jQuery('#cd-primary-nav-secondary-desktop > li > a > span.menuarrow > svg').removeClass('fa-chevron-left').addClass('fa-chevron-down');
            }
            jQuery('.cd-main-content').removeClass('usa-mobile_nav-active');
        }
        toggleSearch('close');
    });

    //submenu items - go back link
    jQuery('.go-back, a.cd-nav-trigger').on('click', function(){
        jQuery(this).parent('ul').addClass('is-hidden').parent('.has-children').parent('ul').removeClass('moves-out');
        // Show social media icons if user clicks the go back button
        if(jQuery('.moves-out').length === 0) {
            jQuery('#mobile-header-social').show();
        }
        // Hide social media icons for apprenticeship page menu
        if(jQuery('.dol-agency-submenu').length) {
            jQuery('#mobile-header-social').hide();
        }
    });

    // For the menu on the apprenticeship page only, show the menu only when the DOL Home menu is clicked and give it a
    // class for styling purposes
    jQuery('a.dol-home-trigger').on('click', function(){
        jQuery('#mobile-header-social').addClass("dol-home-social").show();
    });

    // Show the menu if user clicks back button while inside the secondary dol home menu on apprenticeship page
    jQuery('.cd-secondary-nav .go-back').on('click', function(){
        jQuery('#mobile-header-social').show();
    });

    function closeNav() {
        jQuery('.cd-nav-trigger').removeClass('nav-is-visible');
        jQuery('.cd-main-header').removeClass('nav-is-visible');
        jQuery('.cd-primary-nav').removeClass('nav-is-visible');
        jQuery('.has-children ul').addClass('is-hidden');
        jQuery('.dol-agency-submenu').addClass('is-hidden');
        jQuery('#mobile-header-social').addClass('is-hidden');
        jQuery('.has-children a').removeClass('selected');
        jQuery('.moves-out').removeClass('moves-out');
        jQuery('.cd-main-content').removeClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
            jQuery('body').removeClass('overflow-hidden');
            jQuery('body').attr("style","overflow:auto");
        });
    }

    function toggleSearch(type) {
        if(type=="close") {
            //close serach
            jQuery('.cd-search').removeClass('is-visible');
            jQuery('.cd-search-trigger').removeClass('search-is-visible');
            jQuery('.cd-overlay').removeClass('search-is-visible');
        } else {
            //toggle search visibility
            jQuery('.cd-search').toggleClass('is-visible');
            jQuery('.cd-search-trigger').toggleClass('search-is-visible');
            jQuery('.cd-overlay').toggleClass('search-is-visible');
            if(jQuery(window).width() > MqL && jQuery('.cd-search').hasClass('is-visible')) jQuery('.cd-search').find('input[type="search"]').focus();
            (jQuery('.cd-search').hasClass('is-visible')) ? jQuery('.cd-overlay').addClass('is-visible') : jQuery('.cd-overlay').removeClass('is-visible') ;
        }
    }

    function checkWindowWidth() {
        //check window width (scrollbar included)
        var e = window,
            a = 'inner';
        if (!('innerWidth' in window )) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        if ( e[ a+'Width' ] >= MqL ) {
            return true;
        } else {
            return false;
        }
    }

    function moveNavigation(){
        var navigation = jQuery('.cd-nav').first();
        var desktop = checkWindowWidth();
        if ( desktop ) {
            navigation.detach();
            navigation.insertBefore('.cd-header-buttons');
        } else {
            navigation.detach();
            navigation.insertAfter('.cd-main-content');
        }
    }
});

jQuery( window ).resize(function() {
    var navarrowdirection = jQuery('#cd-primary-nav-secondary-desktop').find('.svg-inline--fa');
    if (jQuery(window).outerWidth() > 993) {
        if (jQuery(navarrowdirection).hasClass('fa-chevron-left')) {
            jQuery(navarrowdirection).removeClass('fa-chevron-left');
            jQuery(navarrowdirection).addClass('fa-chevron-down');
        }
    }
});